<template>
  <div class="select-version-conatiner-wrap">
    <!-- 标题 -->
    <div class="top-head-left">
      <img :src="protectEasyLogo" style="width: 115px;" />
    </div>
    <div class="select-version-conatiner">
      <ul class="select-version-content">
        <li class="select-list">
          <div class="item-top">
            <h2>
              {{
                $t("permission_configuration_management.smsLogin.TrialVersion")
              }}
            </h2>
            <p>
              {{
                $t(
                  "permission_configuration_management.smsLogin.trialVersionDesc"
                )
              }}
            </p>
          </div>
          <div class="item-middle">
            <h3>
              {{ $t("permission_configuration_management.smsLogin.function") }}
            </h3>
            <ul>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t("permission_configuration_management.smsLogin.Dashboard")
                }}
              </li>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t(
                    "permission_configuration_management.smsLogin.ResourceAlarmManagement"
                  )
                }}
              </li>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t(
                    "permission_configuration_management.smsLogin.CaseWorkOrderSystem"
                  )
                }}
              </li>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t(
                    "permission_configuration_management.smsLogin.BillManagement"
                  )
                }}
              </li>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t(
                    "permission_configuration_management.smsLogin.CMDBFunctionSomeResources"
                  )
                }}
              </li>
            </ul>
          </div>
          <div class="item-bottom">
            <!-- 跳转到注册界面 -->
            <a
              href="https://sme.sh-silverlining.com/sme/index.html#/login?redirect=%2Flogin%3Fredirect%3D%252Flogin"
              >{{
                $t("permission_configuration_management.smsLogin.FreeTrial")
              }}</a
            >
          </div>
        </li>
        <li class="select-list">
          <div class="item-top">
            <h2>
              {{
                $t(
                  "permission_configuration_management.smsLogin.OfficialEdition"
                )
              }}
            </h2>
            <p>
              {{
                $t(
                  "permission_configuration_management.smsLogin.trialVersionDescOfficial"
                )
              }}
            </p>
          </div>
          <div class="item-middle">
            <h3>
              {{
                $t(
                  "permission_configuration_management.smsLogin.OfficialFunction"
                )
              }}
            </h3>
            <ul>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t(
                    "permission_configuration_management.smsLogin.InstrumentClusterEnhanced"
                  )
                }}
              </li>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t(
                    "permission_configuration_management.smsLogin.ResourceAlarmManagementEnhancedVersion"
                  )
                }}
              </li>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t(
                    "permission_configuration_management.smsLogin.TimingSwitch"
                  )
                }}
              </li>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t(
                    "permission_configuration_management.smsLogin.ApprovalProcess"
                  )
                }}
              </li>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t(
                    "permission_configuration_management.smsLogin.BillManagementEnhancedVersion"
                  )
                }}
              </li>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t("permission_configuration_management.smsLogin.PachEasy")
                }}
              </li>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t(
                    "permission_configuration_management.smsLogin.ConfigurationManagementEnhanced"
                  )
                }}
              </li>
              <li>
                <Icon type="md-checkmark" />
                {{
                  $t(
                    "permission_configuration_management.smsLogin.ResourceLabelManagement"
                  )
                }}
              </li>
            </ul>
          </div>
          <div class="item-bottom">
            <a
              href="https://sme.sh-silverlining.com/sme/index.html#/login?redirect=%2Flogin%3Fredirect%3D%252Flogin"
              >{{
                $t("permission_configuration_management.smsLogin.applyTrial")
              }}</a
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      protectEasyLogo: require("../../../../../static/images/silverlining-logo.png"),
      companyIdList: [],
      departmentList: []
    };
  },
  methods: {
    // 跳转到注册
    register: function() {
      // 为什么会先跳转到登录呢
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        // 获取部门列表数据
        this.$api.user
          .listDepartmentRegister("language", localStorage.getItem("locale"))
          .then(res => {
            this.departmentList = res.data;
            // 路由跳转到注册界面 并传数组过去
            this.$router.push({
              path: "/register",
              query: {
                companyIdList: this.companyIdList,
                departmentList: this.departmentList
              }
            });
          });
      });
    }
  },
  mounted() {
    this.$i18n.locale = localStorage.getItem("locale");
  }
  // beforeRouteLeave(to, from, next) {
  //   console.log("dshacha", to, from, next);
  //   if (to.path == "/register") {
  //     console.log(to.path, "cece");
  //     this.$router.push({
  //       path: "/register",
  //       query: {
  //         companyIdList: this.companyIdList,
  //         departmentList: this.departmentList
  //       }
  //     });
  //     next();
  //   }
  // }
};
</script>

<style scoped>
.select-version-conatiner-wrap {
  background-color: #2d3a4b;
  padding: 10px;
  height: 100%;
  overflow: auto;
}
.select-version-conatiner {
  width: 100%;
  padding-top: 60px;
}
.top-head-left {
  float: left;
  padding: 10px;
}
.select-version-content {
  width: 1220px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  justify-content: space-around;
}
.select-list {
  display: inline-block;
  background-color: #365473;
  width: 450px;
  height: 776px;
  /* border: 2px solid #ecf0f5; */
  border-radius: 10px;
  vertical-align: top;
  letter-spacing: 0;
}
.select-list:hover {
  /* border-top: 1px solid #fff; */
  box-shadow: 0 0 16px rgba (31, 84, 167, 0.1);
}
.select-list .item-top {
  background: #365473;
  height: 150px;
  padding-top: 40px;
  border-bottom: #eaeef3 1px solid;
  color: #fff;
  border-radius: 10px 10px 0 0;
}
.item-top h2 {
  font-size: 34px;
  line-height: 44px;
  font-weight: normal;
}
.item-top p {
  font-size: 16px;
  line-height: 44px;
}
.item-middle {
  margin-left: 110px;
  height: 500px;
  text-align: left;
}
.item-middle h3 {
  color: #fff;
  font-size: 16px;
  line-height: 36px;
  font-weight: normal;
  text-align: left;
  padding-top: 35px;
}
.item-middle ul {
  padding-top: 20px;
  overflow: auto;
  height: 345px;
}
.item-middle ul li {
  display: inline-block;
  text-align: left;
  width: 320px;
  font-size: 16px;
  line-height: 36px;
  color: #fff;
}
.item-middle ul li i {
  color: #fff;
  font-size: 22px;
  margin-right: 10px;
  vertical-align: middle;
}
.item-bottom a {
  background: linear-gradient(to right, #3582fb, #8fbafb);
  display: inline-block;
  width: 260px;
  height: 48px;
  border-radius: 24px;
  line-height: 48px;
  font-size: 14px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/user/SelectVersion.vue